import val1 from "../../assets/val1.png";
import val2 from "../../assets/val2.png";
import val3 from "../../assets/val3.png";
import val4 from "../../assets/val4.png";
import val5 from "../../assets/val5.png";
import { StyledContainer, StyledMain } from "./styles";

import "react-responsive-carousel/lib/styles/carousel.min.css";

import CarrouselComponent from "../Carrousel";
import Header from "../Global/Header";

export default function FirstHome() {
	const flipperImages = [val1, val2, val3, val4, val5];

	return (
		<>
			<StyledMain>
				<StyledContainer>
					<CarrouselComponent autoPlay>
						{flipperImages.map((src: string, i: number) => {
							return <img className="flipper_image" src={src} alt="" key={i} />;
						})}
					</CarrouselComponent>
				</StyledContainer>
			</StyledMain>

			<div className="opacity"></div>
		</>
	);
}
